// Some platforms need to adjust the window height.
export default function getWindowHeightAdjustment() {
    return 0;
}
